import styled from 'styled-components';
import { createElement } from 'react';

const StyledH4 = styled.span`
  .typography {
    font-weight: ${({ $weight }) => $weight || 'normal'};
    font-size: ${({ $size }) => $size || '16px'};
    line-height: ${({ $lineHeight }) => $lineHeight || '21px'};
    background: ${({ $backgroundTd }) => $backgroundTd || 'transparent'};
    font-family: 'Montserrat arm2';
    color: ${({ $color }) => $color || '#262626'};
    margin: ${({ $margin }) => $margin || '0'};
    min-width: ${({ $minWidth }) => $minWidth || 'auto'};
    max-width: ${({ $maxWidth }) => $maxWidth || 'auto'};
    display: ${({ $display }) => $display || 'block'};
    text-align: ${({ $align }) => $align || 'left'};
    text-transform: ${({ $transform }) => $transform || 'unset'};
    padding: ${({ $padding }) => $padding};
    @media (max-width: 768px) {
      font-size: ${({ $xsSize }) => $xsSize || '16px'} !important;
      padding: ${({ $xsPadding }) => $xsPadding};
    }
  }
`;

function Typography({
  variant = 'p',
  text,
  className = '',
  weight,
  size,
  lineHeight,
  backgroundTd,
  color,
  margin,
  minWidth,
  maxWidth,
  display,
  align,
  transform,
  padding,
  xsSize,
  xsPadding,
  ...props
}) {
  return (
    <StyledH4
      $weight={weight}
      $size={size}
      $lineHeight={lineHeight}
      $backgroundTd={backgroundTd}
      $color={color}
      $margin={margin}
      $minWidth={minWidth}
      $maxWidth={maxWidth}
      $display={display}
      $align={align}
      $transform={transform}
      $padding={padding}
      $xsSize={xsSize}
      $xsPadding={xsPadding}
      {...props}
    >
      {createElement(variant, { className: `typography  ${className}` }, text)}
    </StyledH4>
  );
}

export default Typography;
